<template>
    <div :class="`m-portal m-portal-${routeType}-main`">    
        <el-button type="success" @click="handleArtiList('article','type1')">文章列表1</el-button>
        <el-button type="success" @click="handleArtiList('article','type2')">文件列表2</el-button>
        <el-button type="success" @click="handleArtiList('dests','')">新闻类别1</el-button>
        <el-button type="success" @click="handleArtiList('dests','')">新闻类别2</el-button>
    </div>
</template>

<script>
    require("../../styles/portal/index-portal.scss");
    export default {
        data() {
            return {routeType:'area'}
        },
        methods:{
            handleArtiList(moudle,field) {
                this.$router.push({path:`/portal/dest/list/${moudle}/${field}`});
            },
            handleArtiDetail(moudle,field,item) {
                this.$router.push({path:`/portal/dest/detail/${moudle}/${field}/${item.areaCode}`});
            },
            handleArtiList(moudle,field) {
                this.$router.push({path:`/portal/arti/list/${moudle}/${field}`});
            },
            handleArtiDetail(moudle,field,item) {
                this.$router.push({path:`/portal/arti/detail/${moudle}/${field}/${item.artiId}`});
            }
        },
        created(){
            // this.$menuFn.setTitle("portal-from-main");
        },
        watch: {
            $route: function (to, from) {                
                if(to.name==='portal-area-main'){
                  //  this.$menuFn.setTitle("portal-from-main");
                }
            }
        }
    }
</script>

<style scoped>

</style>